@use '@/styles/tokens' as *;

.layout {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 8px 8px 4px;
  text-align: center;
}

.iconWrap {
  display: grid;
  place-items: center;
  width: 76px;
  height: 76px;
}

.icon {
  width: 76px;
  height: 76px;
  object-fit: contain;
  z-index: 1;
}

.successIcon {
  width: 76px;
  height: 76px;
  color: var(--status-success);
  z-index: 1;
}

.title {
  margin: 0;
  font-family: $font-family-heading;
  font-size: $font-size-2xl;
  font-weight: $font-weight-regular;
  letter-spacing: -0.02em;
  color: var(--text-primary);
}

.subtitle {
  margin: 0;
  font-size: $font-size-md;
  color: var(--text-muted);
}

.pattern {
  top: -24px;
  left: 0;
  width: 100%;
  height: 60%;
  z-index: 0;
}
